import React from "react";

const ClearAllFilter = ({ setTableSearchInput, setSearchTerms, clearAllFilters, tableDetail }) => {
  const clearAllFilter = () => {
    localStorage.removeItem(`sort-${tableDetail.tableHeading}`);
    setTableSearchInput("");
    setSearchTerms({});
    clearAllFilters();

    if (tableDetail?.setQuiFilter) {
      tableDetail.setQuiFilter();
    }
  };
  return (
    <button className="p-1 text-xs text-DF4321 border hover:border-DF4321" onClick={clearAllFilter}>
      Clear All
    </button>
  );
};

export default ClearAllFilter;
